module.exports = __webpack_public_path__ + "img/backlog-helper.a620bffb.png";